import postWithToken from './base/post-with-token'

const addCustomerSiteContact = (id, urlDetailCustomer) => postWithToken(`/customer/${id}/contact?type=${urlDetailCustomer}`)

export default addCustomerSiteContact